module.exports = __webpack_public_path__ + "img/unionpay.3eddc53d.svg";